import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { account, ID, databases } from '../config/appwrite';
import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { UsuariosRelaciones } from '../models/usuarios-relaciones.model';
import { AppwriteException, Query } from 'appwrite';

@Injectable({ providedIn: 'root' })

export class UserService {
  constructor(private http: HttpClient) { }

  private DATABASE_NAME = environment.databaseName;

  /**
   * createUser();
   * @param email
   * @param password
   * @returns
   */
  async createUser(email: string, password: string): Promise<any> {
      try {
        return await account.create(ID.unique(), email, password);
    } catch (error: any) {
        // console.log("Error en servicio:", error.type, error.message);
        return Promise.reject(error);
    }
  }

  /**
   * createRelatioUser()
   * @param data
   * @returns
   */
  async createRelationUser(data: any): Promise<any> {
    return databases.createDocument(
      this.DATABASE_NAME,
      'usuariosRelaciones',
      ID.unique(),
      data
    );
  }

  /**
   *
   * @param idUserLogin
   * @returns
   */
  async getUserRole(idUserLogin: string): Promise<any> {
    return databases.listDocuments<UsuariosRelaciones>(
      this.DATABASE_NAME,
      'usuariosRelaciones',
      [Query.equal('idUserLogin', [idUserLogin])]
    ).then(response => response.documents);


  }

  /**
   * sendEmailRecoveryPassword()
   * Se crea correo para enviar a la persona que se le asigne una nueva cuenta
   * @returns
   */
  sendEmailPacienteRecoveryPassword(email: string): Promise<any> {
    return account.createRecovery(
      email,
      environment.urlSitePacientes + '/account/change-password'
    );
  }




  // Función para consultar según la tabla recibida y el id del usuario recibido
  async getUserByTipouserIduser(idUser: string, tabla: string): Promise<any> {
    try {
      const response = await databases.getDocument(this.DATABASE_NAME, tabla, idUser,[
      Query.select(['nombre'])
    ]);
    return { nombre: response.nombre };
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
  }


  // Función para consultar por el id del usuario

  async validateVerification(userId: string, token: string): Promise<boolean> {
    try {
      const response = await account.updateVerification(userId, token);
      console.log('Verificando usuario:', response);
      // Retorna false si el código es 401, true en cualquier otro caso
      return response['code'] !== 401;
    } catch (error) {
      console.error('Error fetching verification:', error);
      // En caso de error, también retornamos false
      return false;
    }
  }


  async validateVerificationd(userId: string,token: string): Promise<any> {
    try {
    return account.updateVerification(userId, token).then((response) => {
     
      console.log('Verificando usuario:', response);
    })
    } catch (error) {
      console.error('Error fetching verification:', error);
      throw error;
    }
  }
}
